import React from 'react'
import { PageAdditionalProps } from 'page-lifecycle-provider'
import { PerthNowPublication } from 'component-library/templates/Publication/PerthNowPublication/PerthNowPublication'
import {
    PublicationRouteProps,
    getPublicationInfoFromRouteResolution,
} from 'component-library/templates/Publication/SharedPublication.routing'
import { createRegisterableComponentWithData } from 'common/routing/page-definition'
import { ArticlePublicationDataDefinitionLoader } from '../ArticlePublicationDataLoader'
import { getPublicationPageProperties } from '../lib/publication-page-properties'
import { getInlinePositionedContent } from '../get-inline-positioned-content'
import { maxSecondLevel } from '../render-publication'
import { getVideoQueue } from '../lib/get-video-queue'

export const PerthNowArticleRegistration = createRegisterableComponentWithData(
    'article',
    ArticlePublicationDataDefinitionLoader,
    (props: PublicationRouteProps, data, services) => {
        const publicationInfo = getPublicationInfoFromRouteResolution(services)
        if (publicationInfo.publication.kind !== 'article') {
            throw new Error('Article component rendered for non-article')
        }

        if (data.loaded) {
            const inlinePositionedContent = getInlinePositionedContent({
                adState: services.adState,
                publication: publicationInfo.publication,
                meta: props.meta,
                log: services.log,
                onEvent: services.onEvent,
                toggles: services.store.getState().toggles,
            })

            return (
                <PageAdditionalProps
                    pageProperties={getPublicationPageProperties(publicationInfo.publication)}
                >
                    <PerthNowPublication
                        data={publicationInfo.publication}
                        inlinePositionedContent={inlinePositionedContent}
                        sectionAssignment={{
                            text: publicationInfo.publication.primaryTopic.title,
                            topic: maxSecondLevel(publicationInfo.publication.primaryTopic),
                            sizing: 'large',
                        }}
                        onEvent={services.onEvent}
                        log={services.log}
                        getVideoQueue={() =>
                            getVideoQueue(services, publicationInfo.publication.id)
                        }
                        heroOptions={{
                            isVideoStickyEnabled: props.isVideoStickyEnabled,
                        }}
                        relatedPublications={data.result.relatedPublications}
                        userTopicPublications={data.result.userTopicPublications}
                        location={services.location}
                        adUnitPath={services.adState.targeting.adUnitPath}
                    />
                </PageAdditionalProps>
            )
        }
        return null
    }
)
